import { ProductDetails } from "modules/products";

const CreateProductPage = () => {
  return <ProductDetails />;
};

export default CreateProductPage;
